import React from 'react';

export const ResponsavelEmailField = ({ record }) => <span>{record?.pagador_id ? record?.pagador_email : ''}</span>;

export default ResponsavelEmailField;
